import React, {FC, useEffect} from 'react';

const ArchiveRoom:FC = () => {
    return (
        <div>
            room
        </div>
    );
};

export default ArchiveRoom;